import { useEffect, useState } from "react";
import { catalogApi } from "@/lib/api/catalog";

export function usePaidResourceFilterTitle(resourceId: string | undefined) {
  const [resourceTitle, setResourceTitle] = useState<string | undefined>();

  useEffect(() => {
    if (!resourceId) {
      setResourceTitle(undefined);
      return;
    }
    let cancelled = false;
    catalogApi
      .getDigitalResource(resourceId)
      .then((resource) => {
        if (!cancelled) setResourceTitle(resource.title);
      })
      .catch(() => {
        if (!cancelled) setResourceTitle(undefined);
      });
    return () => {
      cancelled = true;
    };
  }, [resourceId]);

  return resourceTitle;
}
